export const API_BASE_URL = "https://mallsylo.onrender.com/v1";
// export const API_BASE_URL = "http://localhost:8000/v1";
